module.exports = "./img/44d1d6372f23e8c311e7435ce55c24c0.jpg";